import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Counter, TextV2 } from '@insights-ltd/design-library/components';
import OrganisationOrGroupList from 'components/OrganisationOrGroupList/OrganisationOrGroupList';
import {
  ApiPaginationProps,
  Pagination,
} from 'components/Pagination/Pagination';
import {
  DEFAULT_CARD_ITEMS_PER_PAGE,
  Paginator,
} from 'components/hooks/usePaginationV2';

import { GroupResponseV2, OrganisationResponse } from 'api';
import { MINIMUM_SEARCH_CHARACTER_LIMIT } from 'api/search';
import { SearchFilterProps } from 'components/SearchFilter/SearchFilter.types';
import { SearchFilter } from 'components/SearchFilter';

type OrganisationTabLayoutProps = {
  heading: string;
  searchProps: SearchFilterProps;
  paginator: Paginator<OrganisationResponse | GroupResponseV2>;
  apiPaginationProps: ApiPaginationProps;
  organisationsOrGroups: (OrganisationResponse | GroupResponseV2)[];
};

const TabLayout = ({
  heading,
  searchProps,
  paginator,
  apiPaginationProps,
  organisationsOrGroups,
}: OrganisationTabLayoutProps) => {
  return (
    <>
      <Box sx={{ mb: (theme) => theme.spacing(spacingSizeMap.S) }}>
        <SearchFilter
          {...searchProps}
          showButton={false}
          minCharacters={MINIMUM_SEARCH_CHARACTER_LIMIT}
          sx={{ mb: (theme) => theme.spacing(spacingSizeMap.S) }}
        />
        <Grid
          container
          spacing={2}
          sx={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Grid size={{ xs: 12, md: 'auto' }}>
            <TextV2
              variant="h3"
              sx={{
                mt: (theme) => theme.spacing(4),
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {heading}
              <Counter
                count={paginator.totalCount}
                size="large"
                sx={{ ml: (theme) => theme.spacing(1) }}
                dataTestId="count-box"
              />
            </TextV2>
          </Grid>
        </Grid>
      </Box>
      <Pagination
        paginator={paginator}
        itemsPerPage={DEFAULT_CARD_ITEMS_PER_PAGE}
        size="small"
        apiPaginationProps={apiPaginationProps}
        show
        sx={{ mt: (theme) => theme.spacing(0.25) }}
      />
      <OrganisationOrGroupList organisationsOrGroups={organisationsOrGroups} />
      <Pagination
        paginator={paginator}
        itemsPerPage={DEFAULT_CARD_ITEMS_PER_PAGE}
        size="small"
        apiPaginationProps={apiPaginationProps}
        show
        sx={{ mt: (theme) => theme.spacing(spacingSizeMap.M) }}
      />
    </>
  );
};

export default TabLayout;
